export const getCurrentTimeInHHMM = (timeZone) => {
    return new Date().toLocaleTimeString('en-HK', {
        timeZone: timeZone,
        hour: '2-digit',
        minute: '2-digit'
    }).toUpperCase();
};

export const fetchDataFromURL = async (url) => {
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Pragma': 'no-cache',
                'Expires': '0'
            }
        });
        return response.json();
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}